import { AnalyticsBrowser } from "@segment/analytics-next";

import type { AdminApp } from "@/misc/types";

export default function (app: AdminApp) {
  let analyticsClient: AnalyticsBrowser | undefined;

  if (import.meta.env.VITE_SEGMENT_WRITE_KEY) {
    analyticsClient = AnalyticsBrowser.load(
      {
        writeKey: import.meta.env.VITE_SEGMENT_WRITE_KEY,
        cdnURL: "https://a.mws.com",
      },
      {
        integrations: {
          "Segment.io": {
            apiHost: "t.mws.com/v1",
            protocol: "https",
          },
        },
      },
    );
  }

  app.provide("$analytics", analyticsClient); // making it available from within Vue components via `inject`
  app.$analytics = analyticsClient; // making it available for other plugins
}
